import { useEffect, useState, useCallback } from "react";
import { MessagesSquare, ChevronDown, ChevronUp } from "lucide-react";
import api from "../../lib/api";
import TripChat from "./TripChat";

/* Collapsible Trip Chat card for the main trip page — shows an unread badge while
   collapsed (polled every 20s); opening it renders the live chat, which marks messages
   as read on the server. */
export default function TripChatCard({ tripId, isOwner }) {
  const [open, setOpen] = useState(false);
  const [unread, setUnread] = useState(0);

  const check = useCallback(async () => {
    try { setUnread((await api.get(`/trips/${tripId}/chat/unread`)).data.unread || 0); }
    catch { /* transient */ }
  }, [tripId]);

  useEffect(() => {
    if (open) { setUnread(0); return undefined; }
    check();
    const iv = setInterval(() => { if (document.visibilityState === "visible") check(); }, 20000);
    return () => clearInterval(iv);
  }, [open, check]);

  return (
    <section className="mb-10" data-testid="trip-chat-card">
      <button onClick={() => setOpen((o) => !o)} data-testid="trip-chat-card-toggle"
        className={`w-full flex items-center gap-3 border px-4 py-3 text-left transition-colors ${open ? "border-indigo-500 bg-indigo-50/60" : "border-indigo-300 bg-indigo-50/40 hover:border-indigo-500"}`}>
        <MessagesSquare className="w-6 h-6 text-indigo-600 shrink-0" />
        <div className="flex-1 min-w-0">
          <div className="font-heading font-900 text-indigo-800 flex items-center gap-2">
            Trip Chat
            {!open && unread > 0 && (
              <span className="bg-rose-600 text-white text-[11px] font-700 px-2 py-0.5 rounded-full" data-testid="trip-chat-unread-badge">
                {unread > 99 ? "99+" : unread} new
              </span>
            )}
          </div>
          <div className="text-xs text-muted-foreground">Talk with everyone on this trip — questions, plan changes, "we've landed!" moments.</div>
        </div>
        {open ? <ChevronUp className="w-4 h-4 text-indigo-600 shrink-0" /> : <ChevronDown className="w-4 h-4 text-indigo-600 shrink-0" />}
      </button>
      {open && <div className="border border-t-0 border-indigo-200"><TripChat tripId={tripId} isOwner={isOwner} /></div>}
    </section>
  );
}
